
module dg.modals {

    export class ModalHeaderController {
        
        public constructor(
            public $scope: ng.IScope) {
        }

        dismiss() {
            let parentScope: any = this.$scope.$parent;
            if (angular.isFunction(parentScope.$dismiss)) {
                parentScope.$dismiss();
            }
        }

    }
    angular.module('dg.modals')
        .component('modalHeader', {
            bindings: {
                modalTitle: '@',
            },
            controller: (ModalHeaderController as any),
            templateUrl: '/digmo/src/modals/modal-header.html'
        });
}
